<template>
  <div class="alert-info-item" @click="handleClick">
    <div class="item-outer-container">
      <div
        :style="{
          margin: '.5rem',
          'background-color': color,
          height: '.5rem',
          width: '.5rem',
          'border-radius': '50%',
        }"
      ></div>
      <div class="key">
        {{ itemKey }}
      </div>
    </div>
    <div class="value" v-if="!loading">
      {{ itemValue || 0 }}
    </div>
    <Loading v-if="loading" :smallar="true"></Loading>
  </div>
</template>
<script>
import Loading from '@/rex-components/rex-loading.vue';

export default {
  components: { Loading },
  data() {
    return {
      type: 'ByCap',
    };
  },
  props: {
    itemKey: { type: String, default: '' },
    itemValue: { type: String, default: '' },
    color: { type: String, required: true },
    loading: { type: Boolean, default: false },
  },
  methods: {
    handleClick() {
      this.$emit('item-clicked', {
        app: this.itemKey,
      });
    },
  },
};
</script>
<style scoped>
.alert-info-item {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  width: 100%;
  background-color: black;
  animation: expand 2s;
  cursor: pointer;
}
.item-outer-container {
  display: flex;
  align-self: flex-end;
}

@keyframes expand {
  0% {
    width: 70%;
  }
  100% {
    width: 100%;
  }
}

.value {
  font-size: 1.4rem;
  font-weight: bold;
}

.key {
  font-size: 1rem;
}
</style>
